<template>
  <div>
    <a-form-model ref="purchaseFormRef" :model="purchaseForm" class="exi_form item_100"
                  :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
      <div>
        采购品目：<span style="color: red" v-if="readonlyPurchase">已经启动了抽取流程，无法进行编辑采购品目</span>
        <a-button v-else type="primary" icon="plus-circle" @click="openPurchaseItems" ghost>选择采购品目及抽取人数
        </a-button>
      </div>
      <a-row v-for="(item,index) in purchaseForm.data" :gutter="20" type="flex" align="middle">
        <a-col :span="4">
          <a-form-model-item label="品目名称"
                             :rules="{required: true, message: '请选择品目名称', trigger: 'blur'}"
                             :prop="'data.'+index+'.fspmmc'">
            <a-input placeholder="品目名称" readOnly
                     v-model="item.fspmmc"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="地区选择"
                             :rules="{required: true, message: '请选择地区', trigger: 'change'}"
                             :prop="'data.'+index+'.address'">
            <dict-cascader v-model="item.address" :changeOnSelect="false"
                           dictKey="COUNTRY.CITY" :disabled="readonlyPurchase"
                           placeholder="地区选择"
                           style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="国家、省库专家"
                             :prop="'data.'+index+'.otherSourceLibrary'">
            <dict-search-select v-model="item.otherSourceLibrary" mode="tags"
                                dictKey="other_expertbank" :disabled="readonlyPurchase"
                                placeholder="国家、省库专家选择"
                                style="width: 90%"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="4" v-if="item.specificProfessionalTitleKey">
          <a-form-model-item label="职称"
                             :prop="'data.'+index+'.specificProfessionalTitleKey'">
            <a-tooltip :key="item.id" :title="item.extras.specificProfessionalTitle" color="green">
              <a-input v-model="item.extras.specificProfessionalTitle" style="text-overflow: ellipsis"
                       placeholder="职称"
                       readOnly></a-input>
            </a-tooltip>
          </a-form-model-item>
        </a-col>
        <a-col :span="2">
          <a-form-model-item label="人数"
                             :rules="{required: true, message: '请输入人数', trigger: 'blur'}"
                             :prop="'data.'+index+'.applyNum'">
            <a-input-number placeholder="人数" style="width: 100%"
                            v-model="item.applyNum"
                            :min="1"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="4" v-if="!readonlyPurchase">
          <a-space>
            <a-button type="primary" @click="openProfessional(item)" ghost>
              职称选择
            </a-button>
            <a-button @click="delPurchaseItems(item.id)" type="danger" ghost>
              移除
            </a-button>
          </a-space>
        </a-col>
      </a-row>
    </a-form-model>
    <choose-purchase-item-v2 ref="items" :visible="purchaseVisible" @success="purchaseSuccess" :apply-id="applyId"
                             @cancel="purchaseVisible=false"/>
    <choose-extract-professional-title ref="professionalRef"
                                       :visible="professionalVisible"
                                       @success="professionalSuccess"
                                       @cancel="professionalVisible=false"/>
  </div>

</template>
<script>
import { PageView } from '@/layouts'
import DictCascader from '@/components/dict/DictCascader.vue'
import ChoosePurchaseItemV2 from '@/epp/expertmain/purchaseitems/ChoosePurchaseItemV2.vue'
import {
  ACTION_TYPE, CONTENT_TYPE, EXPERT_AREA_ADDRESS
} from '@/epp/sysContentMange/util/sysContentMangeUtil'
import { GetListByDto } from '@/epp/sysContentMange/api/sysContentMangeApi'
import DictSearchSelect from '@/components/dict/DictSearchSelect.vue'
import ChooseExtractProfessionalTitle from '@/epp/expertmain/purchaseitems/ChooseExtractProfessionalTitle.vue'
import ChooseExpertProfessionalTitle from '@/epp/expertmain/purchaseitems/ChooseExpertProfessionalTitle.vue'

const uuidv4 = require('uuid/v4')

export default {
  name: 'PurchaseForm',
  props: {
    purchaseForm: {
      type: Object,
      default () {
        return {
          data: [],
        }
      }
    },
    applyId: {
      type: String,
      default: undefined
    },
    readonlyPurchase: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ChooseExpertProfessionalTitle,
    ChooseExtractProfessionalTitle,
    DictSearchSelect,
    DictCascader,
    PageView,
    ChoosePurchaseItemV2,
  },
  data () {
    return {
      purchaseVisible: false,
      areaAddress: '44,4401',
      professionalVisible: false,
    }
  },
  computed: {},
  created () {
    this.initDefaultData()
  },
  methods: {
    //打开职称窗口
    openProfessional (item) {
      this.professionalVisible = true
      let result = []
      let keyArr = item.specificProfessionalTitleKey?.split('；') || []
      let nameArr = item.extras.specificProfessionalTitle?.split('；') || []
      for (let i = 0; i < keyArr.length; i++) {
        const data = {}
        data['name'] = nameArr[i]
        data['value'] = keyArr[i]
        result.push(data)
      }
      this.$refs.professionalRef.preView(result, item.id)
    },
    //选择职称成功后
    professionalSuccess (data, id) {
      this.professionalVisible = false
      let newData = this.purchaseForm.data.filter(item => item.id === id)[0]
      if (newData) {
        newData.extras.specificProfessionalTitle = data.map(item => item.name).join('；')
        newData.specificProfessionalTitleKey = data.map(item => item.value).join('；')
      }
    },
    async initDefaultData () {
      try {
        let dto = {
          contentKey: `${EXPERT_AREA_ADDRESS}`,
          actionType: `${ACTION_TYPE.system}`,
          contentType: `${CONTENT_TYPE.TEXT}`
        }
        let res = await GetListByDto(dto)
        if (res.code === 200 && res.result) {
          let areaAddress = res.result.filter(item => item.contentKey === EXPERT_AREA_ADDRESS)[0]
          this.areaAddress = areaAddress?.contentResource
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
      }
    },
    purchaseSuccess (data) {
      this.purchaseVisible = false
      data.forEach(item => {
        let customJson = {
          'id': uuidv4(),
          'fid': item.fid,
          'fspmmc': item.fspmmc,
          'fspmbm': item.fspmbm,
          'address': undefined,
          'applyNum': 1,
          'otherSourceLibrary': undefined,
          'specificProfessionalTitleKey': undefined,
          'extras': {
            'specificProfessionalTitle': undefined
          }
        }
        this.purchaseForm.data.push(customJson)
      })
    },
    openPurchaseItems () {
      this.purchaseVisible = true
      this.$refs.items.preView(this.purchaseForm.data, undefined)
    },
    delPurchaseItems (id) {
      const newData = this.purchaseForm.data.filter(item => item.id !== id)
      this.purchaseForm.data = [...newData]
    },
  }
}

</script>

<style scoped lang="less">

</style>
